import { Flex, FlexProps, mdBumps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../../../../infrastructure/internationalisation'
import { toDateTime } from '../../../../../../../util/date'

const tKey = TKey('components.effective-at')

interface EffectiveAtProps extends FlexProps {
  effectiveAt: string
}

export const EffectiveAt: FunctionComponent<EffectiveAtProps> = ({
  effectiveAt,
  ...props
}) => {
  const { t } = useWriskTranslation()

  return (
    <Flex p={mdBumps} borderTopWidth={1} {...props}>
      <Typo fontWeight='bold' mr={2}>
        {t(tKey('date'))}
      </Typo>
      <Typo>{t(tFormats('datetime.medium'), { value: toDateTime(effectiveAt) })}</Typo>
    </Flex>
  )
}
